<div class="card">
    <app-header titulo="Fornecedores" descricao="Cadastro de fornecedor"></app-header>

    <p-table [value]="fornecedores" dataKey="id" #dt [loading]="loading"
        [globalFilterFields]="['cdFornecErp','cdFornecPims','noCpfcnpj','mensagem']"
        styleClass="p-datatable-sm p-datatable-striped p-datatable-gridlines" [rowsPerPageOptions]="[20, 50, 100]"
        [paginator]="true" [rows]="20" [showCurrentPageReport]="true"
        currentPageReportTemplate="Mostrando de {first} até {last} de {totalRecords} registros">
        <ng-template pTemplate="caption">

            <div class="flex justify-content-end flex-wrap">
                <div class="flex align-items-center justify-content-center">
                    <button class="ml-3 mr-3" pButton (click)="exportar()" style="font-size: 1.0rem"
                        [loading]="loadingSincronizar" icon="pi pi-file-excel" label="Exportar"></button>
                </div>
                <div class="flex align-items-center justify-content-center">
                    <span class="p-input-icon-left ml-auto">
                        <i class="pi pi-search"></i>
                        <input pInputText type="text" (input)="dt.filterGlobal($any($event.target)?.value, 'contains')"
                            placeholder="Pesquisar" />
                    </span>
                </div>
                <div class="flex align-items-center justify-content-center">
                    <button class="ml-3" pButton pRipple icon="pi pi-refresh" (click)="atualizar()"
                        [loading]="loading"></button>
                </div>
            </div>
        </ng-template>
        <ng-template pTemplate="header">
            <tr>
                <th>Código ERP</th>
                <th>Código PIMS</th>
                <th>Tipo</th>
                <th>CNPJ/CPF</th>
                <th>Razão Social</th>
                <th>Integrado?</th>
                <th>Data Integrado</th>
                <th>Mensagem</th>
            </tr>
        </ng-template>
        <ng-template pTemplate="body" let-fornecedor>
            <tr>
                <td>{{fornecedor.cdFornecErp}}</td>
                <td>{{fornecedor.cdFornecPims}}</td>
                <td>{{fornecedor.fgTpPessoa}}</td>
                <td>{{fornecedor.noCpfcnpj}}</td>
                <td>{{fornecedor.deFornec}}</td>
                <td><app-tag-status [status]="fornecedor.fgStatusInteg"></app-tag-status></td>
                <td>{{fornecedor.dtIntegPims | date: 'dd/MM/yyyy HH:mm'}}</td>
                <td>{{fornecedor.deMensagemInteg}}</td>
            </tr>
        </ng-template>
        <ng-template pTemplate="emptymessage">
            <td colspan="7">Não há fornecedores integrados</td>
        </ng-template>
    </p-table>
</div>